export enum ClaimOverviewGroupCodeEnum {
    Car = '0002',
    Date = '0014',
    Cause = '0015',
    Location = '0016',
}
